export default __webpack_public_path__ + "static/video-thumb-placeholder-2-4807341cd2d80d7b5090a967b6a25720.jpg";